/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$grid-control-h-gutter-phone: 16px !default;
$grid-control-h-gutter-tablet: 24px !default;
$grid-control-h-gutter-desktop: 40px !default;
$grid-control-h-gutter-desktop-large: 48px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

eon-ui-grid-control-column {
  display: flex;
  flex-direction: column;

  > * {
    margin: 0;
    padding: 0;
  }

  *,
  *::after,
  *::before {
    box-sizing: border-box;
    outline: 0 none;
    text-rendering: optimizelegibility;
  }

  > * {
    margin-bottom: $grid-control-h-gutter-desktop-large;

    @include for-size(desktop) {
      margin-bottom: $grid-control-h-gutter-desktop;
    }

    @include for-size(tablet) {
      margin-bottom: $grid-control-h-gutter-tablet;
    }

    @include for-size(phone) {
      margin-bottom: $grid-control-h-gutter-phone;
    }
  }

  > *:last-child:not(eon-ui-headline) {
    margin-bottom: 0;
  }

  > eon-ui-spacer {
    margin: 0 !important;
  }

  > eon-ui-sitelink {
    @include for-size(tablet) {
      margin-bottom: calc(-#{$grid-control-h-gutter-tablet} + 8px) !important;
    }

    @include for-size(phone) {
      margin-bottom: calc(-#{$grid-control-h-gutter-phone} + 8px) !important;
    }
  }
}

eon-ui-grid-control-column[data-remove-horizontal-gutter] {
  > * {
    margin-bottom: 0;
  }
}
